import { Box, Button, Dialog, Portal, RadioGroup, Skeleton, VStack } from '@chakra-ui/react'
import { useCallback, useEffect, useState } from 'react'
import { providersTypeOptions } from './MailingProviders.constants'
import { useFetchProvidersSettings } from './hooks/useFetchProvidersSettings'
import { useSaveProvidersSettings } from './hooks/useSaveProvidersSettings'

export const MailingProviders = ({ isOpen, onClose }) => {
  const [provider, setProvider] = useState()

  const { data, isLoading: settingsIsLoading } = useFetchProvidersSettings(isOpen)
  const { mutate, isLoading: settingsIsSaving } = useSaveProvidersSettings()

  useEffect(() => {
    if (data) {
      setProvider(data.currentProvider)
    }
  }, [data])

  const onSubmitHandle = useCallback(() => {
    mutate(provider)
  }, [provider])

  const onChangeProvider = useCallback((details) => {
    setProvider(details.value)
  }, [])

  const formIsDisabled = settingsIsLoading || settingsIsSaving
  const availableProviders = data?.availableProviders || []

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Оператор рассылки email</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>
            <Dialog.Body>
              <RadioGroup.Root
                colorPalette="orange"
                size="lg"
                w="full"
                onValueChange={onChangeProvider}
                value={provider}
              >
                <VStack>
                  {providersTypeOptions.map(({ title, value }) => (
                    <Skeleton key={value} h="40px" loading={!data} borderRadius="5px" w="full">
                      {availableProviders.includes(value) ? (
                        <RadioGroup.Item value={value} disabled={formIsDisabled} cursor="pointer">
                          <RadioGroup.ItemHiddenInput />
                          <RadioGroup.ItemIndicator cursor="pointer" />
                          <RadioGroup.ItemText>{title}</RadioGroup.ItemText>
                        </RadioGroup.Item>
                      ) : null}
                    </Skeleton>
                  ))}
                </VStack>
              </RadioGroup.Root>
              <Box pt="30px">
                <Button
                  onClick={onSubmitHandle}
                  colorPalette="orange"
                  loading={settingsIsLoading || settingsIsSaving}
                >
                  Обновить
                </Button>
              </Box>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
